export default "__VITE_ASSET__ca10a8de__"